<template>
  <div>
    <mavon-editor class="md" :value="newsDetailData" :subfield="configs.subfield" :defaultOpen="configs.defaultOpen"
      :toolbarsFlag="configs.toolbarsFlag" :editable="configs.editable" :scrollStyle="configs.scrollStyle"
      :navigation="configs.navigation" style="height:100%" :imageClick="imageClicks"/>
  </div>
</template>
<script>
export default {
  props:['newsDetailData','imageClicks'], 
  data() {
    return {
      configs: {
        subfield: false, // 单双栏模式
        defaultOpen: "preview", // edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        editable: false, // 是否允许编辑
        toolbarsFlag: false, // 工具栏是否显示
        scrollStyle: false, // 开启滚动条样式
        navigation: false,
      },
    };
  },
  // created(){
  //   this.addUrl()
  // },
  // watch:{
  //   'configs.navigation':function(news,olds){
  //         console.log(news,olds,"的大达瓦达瓦")
  //       },
  //       immediate: true,
  //       deep:true
  // },
  mounted() {
    // this.getclick()
    // console.log(this.$props.inallL,"inallL")
    // this.$nextTick(()=>{
    //  var add=this.$refs.aaa.$el.children[1].children[2].children[1].children
    // if(add.length<=1){
    //   var acc =document.querySelector(".v-note-navigation-wrapper")
    //     acc.style.overflow="hidder"
    //     this.configs.navigation=false
    // }
    // console.log(add,"大顶顶顶顶顶")
    // })
  },
  methods: {
    //    addUrl() {
    //   this.$nextTick(function () {
    //     console.log("add")
    //     let _aList = document.querySelectorAll(".v-note-navigation-content a");
    //     for (let i = 0; i < _aList.length; i++) {
    //       let _aParent = _aList[i].parentNode;
    //       let _a = _aParent.firstChild;
    //       if (!_a.id) continue; // 把不属于导航中的a标签去掉，否则会报错
    //       let _text = _aParent.lastChild;
    //       let text = _text.textContent;
    //       _a.href = "#" + _a.id;
    //       _a.innerText = text;
    //       _aParent.removeChild(_text);
    //        _a.style.color = "red";
    //     }
    //   });
    // },
    //       getclick(){
    //          this.add= this.$props.inallL
    //          var that=this;
    // this.$nextTick(() => {
    //         document.querySelector(".v-note-navigation-content").onclick = function(e){
    //         e = e || window.event;
    //         var target = e.srcElement || e.target
    //             //tagName = target.tagName.toLowerCase(),
    //         // this.add.allLi = document.querySelector(".v-note-navigation-content").getElementsByTagName("h1")
    //         // this.add.allL2 = document.querySelector(".v-note-navigation-content").getElementsByTagName("h2")
    //         // console.log(allLi,allL2,"allL2allL2allL2allL2allL2allL2allL2allL2")
    //         for(var i=0;i<that.add.allLi.length;i++){
    //             if(target == that.add.allLi[i]){
    //                 that.add.allLi[i].style.color = "red";
    //             }else{
    //                 that.add.allLi[i].style.color = "darkgray";
    //             }
    //         }
    //         for(var i=0;i<that.add.allL2.length;i++){
    //             if(target == that.add.allL2[i]){
    //                 that.add.allL2[i].style.color = "red";
    //             }else{
    //                 that.add.allL2[i].style.color = "darkgray";
    //             }
    //         }
    //     }
    //   });
    //       }

  }

};
</script>
<style lang="scss" scoped>
/deep/ .v-note-wrapper {
  position: relative;
  z-index: 2 !important;


}

/deep/ .markdown-body h1 {
  border: none !important;
   margin-top:0px !important;
}
/deep/ .markdown-body h2 {
  border: none !important;
   margin-top:0px !important;
}
/deep/ .markdown-body h3 {
  border: none !important;
  margin-top:0px !important;
}
/deep/ .markdown-body h4 {
  border: none !important;
  margin-top:0px !important;
}
/deep/ .markdown-body h5 {
  border: none !important;
  margin-top:0px !important;
}
/deep/ .markdown-body h6 {
  border: none !important;
  margin-top:0px !important;
}

/deep/ .shadow {
  box-shadow: 0px 0px 0  !important
}
/deep/ .v-show-content{
  background-color: #fff !important;
  padding: 0px !important;
}
/deep/ .markdown-body img{
  width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/mdPreview.vue